import axios from 'axios';
import { DateTime } from 'luxon';
import type { SectionItem } from '../types/modules';

export default class ModulesService
{
    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<ListItemModel>>(`admin/studio/modules`, {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`admin/studio/modules/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post<Resource<FormModel>>(`admin/studio/modules`, model)).data;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put<Statement>(`admin/studio/modules/${id}`, model)).data;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`admin/studio/modules/${id}`)).data as Statement;
    }

    public static async export(id: number)
    {
        const filename = `module-${DateTime.now().toFormat('yyyy-MM-dd_HH-mm-ss')}.json`;

        return axios
            .get(`admin/studio/modules/${id}/export`)
            .then((res) =>
            {
                if (res.status == 200)
                {
                    const blob = new Blob([JSON.stringify(res.data, null, 4)], { type: 'application/json' });

                    if ((window.navigator as any).msSaveOrOpenBlob)
                    {
                        (navigator as any).msSaveBlob(blob, filename);
                    }
                    else
                    {
                        const a = document.createElement('a');

                        document.body.appendChild(a);
                        a.href = window.URL.createObjectURL(blob);
                        a.download = filename;
                        a.target = '_blank';
                        a.click();
                        a.remove();
                    }
                }
            });
    }

    public static async import(definition: any)
    {
        return (await axios.post<Statement>(`admin/studio/modules/import`, definition)).data;
    }

    public static async wizard(id: number, module: WizardFormModel, section: SectionItem, endpoints: EndpointModel[])
    {
        return (await axios.post<{ id: number }>(`admin/studio/modules/wizard`, {
            id,
            module,
            section,
            endpoints
        })).data;
    }
}

export interface FilterModel
{
    name: string;
}

export interface ListItemModel
{
    id: number;
    name: string;
    icon: string;
    isActive: string;
    isHidden: string;
}

export interface FormModel
{
    id: number;
    categoryId: number;
    name: string;
    symbol: string;
    icon: string;
    isActive: boolean;
    isHidden: boolean;
    sections: SectionItem[];
}

export interface WizardFormModel extends FormModel
{
    endpoints: string[];
}

interface EndpointModel
{
    method: HttpMethod;
    name: string;
}
